import Ajax from '../../../../util/ajax';
export function isEffectDelayedAllOffVariant(s) {
    return s == 'fade to off in 0.8 seconds' || s == 'no fade' || s == '50% dim down in 0.8 seconds then fade to off in 12 seconds';
}
export function isEffectDyingLightVariant(s) {
    return s == '20% dim up in 0.5s then fade to off in 1 second';
}
// export type EffectType = Effect['type']
export function zigbeeOffWithEffect(nid, eid, effect) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/6/command/off-with-effect';
        ajax.post(url, effect);
    };
}
